export default "https://cdn-static.gokick.com/assets/643951300d065933ed58add7baf5b7b086396c88/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";